const filterOtherCountryEmbassy = (options) => {
  return options.filter((c) => c.isOtherCountryEmbassy == 0)
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'filterOtherCountryEmbassy':
      return filterOtherCountryEmbassy(actionParams)

    default:
      break
  }
  return {
    filterOtherCountryEmbassy
  }
}
